import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { config } from '@app/core/app-config';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { TranslocoRootModule } from '@app/transloco-root.module';
import { UiModule } from '@app/ui/ui.module';

interface RatePlan {
  uuid: string;
  name: string;
  is_primary: boolean;
  multiple_guest_markup: {
    type: 'amount' | 'percent';
    value: number;
  };
}

interface ListingWithRatePlan {
  listing_id: string;
  name: string;
  currency: string;
  platform: string;
  picture: string;
  rate_plans: RatePlan[];
}

@Component({
  standalone: true,
  selector: 'sbnb-property-booking-rate-plans',
  templateUrl: './property-booking-rate-plans.component.html',
  styleUrls: ['./property-booking-rate-plans.component.scss'],
  imports: [CommonModule, FormsModule, UiModule, TranslocoRootModule],
})
export class PropertyBookingRatePlansComponent implements OnInit {
  @Input() propertyId: any;
  @Input() propertyCurrency: string;
  @Input() propertyName: string;

  config = config;

  saveStatus = 0;

  listingsRatePlans: ListingWithRatePlan[];
  selectedRatePlans: { [key: string]: RatePlan } = {};

  changesMade = false;

  hasMultipleRatePlans = false;

  extraGuestChargesEnabled = true;

  constructor(private readonly propertiesService: PropertiesService) {}

  ngOnInit(): void {
    this.getRatePlanDetails();
  }

  getRatePlanDetails() {
    this.propertiesService.getBookingRatePlans(this.propertyId).subscribe((res) => {
      if (res.error) {
        return;
      }
      this.listingsRatePlans = res;

      this.listingsRatePlans.forEach((listing) => {
        if (listing.rate_plans.length > 1) {
          this.hasMultipleRatePlans = true;
        }

        listing.rate_plans.forEach((ratePlan) => {
          if (ratePlan.is_primary) {
            this.selectedRatePlans[listing.listing_id] = ratePlan;
          }
        });
      });
    });
  }

  updateRatePlan(listingId: string, event: MatSelectChange) {
    this.saveStatus = 1;

    this.changesMade = true;
    const listing = this.listingsRatePlans.find((x) => x.rate_plans.some((y) => y.uuid === event.value));
    if (listing) {
      this.selectedRatePlans[listingId] = listing.rate_plans.find((y) => y.uuid === event.value);
    }

    const payload = Object.assign({}, this.selectedRatePlans[listingId]);
    payload.is_primary = true;

    this.propertiesService.updateRatePlan(this.propertyId, listingId, payload).subscribe((res) => {
      this.saveStatus = 2;

      setTimeout(() => {
        this.saveStatus = 0;
      }, 2000);
    });
  }

  openSupportDocumentation() {
    window.open('https://my.hospitable.com/support-documentation/article/8890057', '_blank');
  }
}
